import { render, staticRenderFns } from "./Legals.vue?vue&type=template&id=c0ee6648&scoped=true&"
import script from "./Legals.vue?vue&type=script&lang=js&"
export * from "./Legals.vue?vue&type=script&lang=js&"
import style0 from "./Legals.vue?vue&type=style&index=0&id=c0ee6648&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0ee6648",
  null
  
)

export default component.exports